import { Component, OnInit } from '@angular/core';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';
import { LoginService } from 'src/app/services/login.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  name: string;
  constructor(private localstorage: LocalstorageService, private _loginservice: LoginService ,private router: Router) {
    this.name=this.localstorage.getname();
  }
  ngOnInit() {
    if(this.name == "null" || this.name == "undefined"){
      this.name = "";
    }
  }

  logoHomePage() {
    this.router.navigate(['/home-page']);
    this.localstorage.removeMenu();
  }
 
  logout() {
    localStorage.removeItem('loginToken');
    this.localstorage.logout();
    this.localstorage.changeLoginStatus(false);
    this.router.navigate(['/login']);
  }
}
